import React from 'react';
import { TimeBlockView } from './TimeBlock.View';
import { useTimeBlockModel } from './TimeBlock.Model';

export const TimeBlock = () => {
  return <TimeBlockView {...useTimeBlockModel()} />
};
